import { RefObject, useEffect } from 'react';
import { CustomButtonColorsType } from './use-dynamic-button-form';

type UseCustomButtonColorsProps = {
  buttonRef: RefObject<HTMLElement>;
  customButtonColorValues?: boolean;
  customButtonColors?: CustomButtonColorsType;
};

export function useCustomButtonColors({
  buttonRef,
  customButtonColorValues,
  customButtonColors,
}: UseCustomButtonColorsProps) {
  const buttonHoverColor =
    customButtonColors?.backgroundHoverColor === 'HEXCOLOR'
      ? customButtonColors?.backgroundHoverHexColor
      : customButtonColors?.backgroundHoverColor || '#006642';
  const buttonTextHoverColor =
    customButtonColors?.textHoverColor === 'HEXCOLOR'
      ? customButtonColors?.textHoverHexColor
      : customButtonColors?.textHoverColor || '#ffffff';
  const buttonBorderHoverColor =
    customButtonColors?.borderHoverColor || '#006642';
  const buttonBorderWidth = customButtonColors?.borderWidth || '0';

  useEffect(() => {
    if (buttonRef.current && customButtonColorValues) {
      buttonRef.current.style.setProperty(
        '--button-hover-background-color',
        buttonHoverColor
      );

      buttonRef.current.style.setProperty(
        '--button-text-hover-color',
        buttonTextHoverColor
      );

      buttonRef.current.style.setProperty(
        '--button-border-hover-color',
        `${buttonBorderWidth}px solid ${buttonBorderHoverColor}`
      );
    }
  }, [
    buttonHoverColor,
    buttonTextHoverColor,
    buttonBorderHoverColor,
    buttonBorderWidth,
    customButtonColorValues,
    buttonRef,
  ]);
}
